export enum IChooseSurveyFormNames {
	clientId = 'clientId',
	startDate = 'startDate',
	endDate = 'endDate',
	query = 'query',
}

export interface IChooseSurveyForm {
	[IChooseSurveyFormNames.clientId]?: string;
	[IChooseSurveyFormNames.startDate]?: string;
	[IChooseSurveyFormNames.endDate]?: string;
	[IChooseSurveyFormNames.query]?: string;
}
